import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseURL } from "../../BaseUrl";
// Function to retrieve token from localStorage
const getToken = () => localStorage.getItem("workManagement");

// API headers including token
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});
export const getAllcompanydata = createAsyncThunk(
    "company/getAllcompanydata",
    async () => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.get(`/company/`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const createcompanydata = createAsyncThunk(
    "company/createcompanydata",
    async (data) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.post(`/company/`,data,getAuthHeaders()
        );
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const getSinglecompanydata = createAsyncThunk(
    "company/getSinglecompanydata",
    async (id) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.get(`/company/${id}`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const updatecompanydata = createAsyncThunk(
    "company/updatecompanydata",
    async (data) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.patch(`/company/`,data,getAuthHeaders()
        );
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  //delete 
export const deleteCompanyData = createAsyncThunk(
  "company/deleteCompanyData",
  async (id) => {
    // console.log("cid===>",cid)
    try {
      const response = await baseURL.delete(`company/${id}`,getAuthHeaders());
      console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
  export const companySlice = createSlice({
    name: "company",
    initialState: {
      companyData: [],
      singleCompanyData:{},
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getAllcompanydata.pending, (state) => {
          state.loading = true;
        })
        .addCase(getAllcompanydata.fulfilled, (state, action) => {
          state.loading = false;
          state.companyData = action.payload;
        })
        .addCase(getAllcompanydata.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
        builder
        .addCase(getSinglecompanydata.pending, (state) => {
          state.loading = true;
        })
        .addCase(getSinglecompanydata.fulfilled, (state, action) => {
          state.loading = false;
          state.singleCompanyData = action.payload;
        })
        .addCase(getSinglecompanydata.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
    },
  });
  
  // SELECTORS
  export const getCompanyData = (state) => state.company.companyData;
  export const getUniqueCompanyData = (state) => state.company.singleCompanyData;
  export const companyerror = (state) => state.company.loading;
  
  // EXPORTS
  export default companySlice.reducer;
  